export default function ScrollToTop (props) {
    return (
        <button onClick={props.handleClick} className='btn-to-top' style={{display: props.visible ? 'inline' : 'none'}}><i className="bi bi-arrow-up-circle-fill h1" style={{color: 'var(--red)'}}></i></button>
    );
}